import { CultureInfo } from "../../Models/Culture/CultureInfo";
import { LocalizationModule } from "../../Modules/Global/LocalizationModule";
import { AxLoad } from "../AxSystem/AxLoad";
import { ConfigDefinition, ConfigHelper } from "./Config/ConfigHelper";

export class PriceHelper {
    cultureInfo: CultureInfo;
    private localizationModule: LocalizationModule;
    private usedCurrencySymbol: string;

    constructor(cultureInfo: CultureInfo, checkCurrencySymbolConfig: boolean) {
        this.localizationModule = AxLoad.GetModule<LocalizationModule>('LocalizationModule');
        this.cultureInfo = !cultureInfo ? this.localizationModule.getCultureInfo() : cultureInfo;
        this.usedCurrencySymbol = this.cultureInfo.CurrencySymbol;

        if (checkCurrencySymbolConfig) {
            ConfigHelper.getBoolConfigValue(ConfigDefinition.StoreCurrencyWebUseIsoSymbol, (currencyWebUseIsoSymbol) => {
                this.usedCurrencySymbol = currencyWebUseIsoSymbol
                    ? this.cultureInfo.CurrencySymbol
                    : this.cultureInfo.CurrencyName;
            });
        }
    }

    GetPriceStringWithDecimalDivisorCalced(totalAmount: number): string {
        const calculatedPrice: number = totalAmount / this.localizationModule.getPriceToDecimalDivisor();

        return jQuery.number(
            calculatedPrice,
            this.cultureInfo.currencyDecimalDigits,
            this.cultureInfo.currencyDecimalSeparator,
            this.cultureInfo.currencyGroupSeparator
        );
    }

    GetPriceString(totalAmount: number): string {
        return jQuery.number(
            totalAmount,
            this.cultureInfo.currencyDecimalDigits,
            this.cultureInfo.currencyDecimalSeparator,
            this.cultureInfo.currencyGroupSeparator
        );
    }

    GetPriceStringWithCurrencySymbol(totalAmount: number): string {
        const price = this.GetPriceString(totalAmount);
        return this.cultureInfo.CurrencyPosition == 0
            ? `${this.usedCurrencySymbol} ${price}`
            : `${price} ${this.usedCurrencySymbol}`;
    }

    GetPrice(price: number): number {
        return price / this.localizationModule.getPriceToDecimalDivisor();
    }
}